import { render, staticRenderFns } from "./SdsEditHistoryEntry.vue?vue&type=template&id=d5c6b056&scoped=true"
import script from "./SdsEditHistoryEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsEditHistoryEntry.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsEditHistoryEntry.vue?vue&type=style&index=0&id=d5c6b056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c6b056",
  null
  
)

export default component.exports